import { isUndefined } from 'lodash';

import fetch from 'utilities/fetch';
import { paths } from 'config/path_helpers';

export const analyticsSaveRecentFilters = async (filters) => {
  fetch(paths.api.statisticRecentFilters(), {
    method: 'POST',
    body: JSON.stringify({ filters })
  });
};

export const fetchMockTestsGradingRequestsStatus = (mockTestId) => {
  return fetch(paths.api.mockTestGradingRequestsStatus(mockTestId)).then((response) => {
    return response.gradingRequests;
  });
};

export const fetchPage = (path) => {
  return fetch(`${path}.json`).then((response) => {
    return response;
  });
};

export const fetchStatistic = (name, filters) => {
  return fetch(paths.api.statistic(name, filters)).then((response) => {
    return response.statistic;
  });
};

export const fetchUserProfile = () => {
  return fetch(paths.api.userProfile()).then((response) => {
    return response.userProfile;
  });
};

export const regradeMockTestsGradingRequests = (mockTestId) => {
  return fetch(paths.api.mockTestGradingRequestsRegrade(mockTestId), {
    method: 'POST'
  }).then((response) => {
    return response.gradingRequests;
  });;
};

export const updateUserProfile = (userProfile) => {
  return fetch(paths.api.userProfile(), {
    method: 'PUT',
    body: JSON.stringify({ userProfile })
  }).then((response) => {
    return response.userProfile;
  });
};
